import { render, staticRenderFns } from "./editExamine.vue?vue&type=template&id=b4c968f4&scoped=true"
import script from "./editExamine.vue?vue&type=script&lang=js"
export * from "./editExamine.vue?vue&type=script&lang=js"
import style0 from "./editExamine.vue?vue&type=style&index=0&id=b4c968f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c968f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4c968f4')) {
      api.createRecord('b4c968f4', component.options)
    } else {
      api.reload('b4c968f4', component.options)
    }
    module.hot.accept("./editExamine.vue?vue&type=template&id=b4c968f4&scoped=true", function () {
      api.rerender('b4c968f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/examine/components/editExamine.vue"
export default component.exports